"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const gs = require("@ivanlog/gs");
const AppControllerBase_js_1 = require("./AppControllerBase.js");
const SocketMessageTypeEnum_js_1 = require("./longPollingClasses/SocketMessageTypeEnum.js");
const LPMessageOrder_js_1 = require("./longPollingClasses/models/LPMessageOrder.js");
class LongPollController extends AppControllerBase_js_1.AppControllerBase {
    constructor(app, url) {
        super(app);
        this._needClose = false;
        this._endPoint = "/admin/api/v1/HotMessages/Sign";
        this._url = "";
        this._onClose = new gs.EventToken();
        this.onClose = new gs.EventGS(this._onClose);
        this._onNewHotOrder = new gs.EventToken();
        this._onHotOrderTaked = new gs.EventToken();
        this._onOrderChanged = new gs.EventToken();
        this._url = url;
        this.onClose = new gs.EventGS(this._onClose);
        app.auth.onRefrehUserToken.addHandler(() => { this.open(); });
        app.auth.onLogout.addHandler(() => { this.close(); });
        this.onHotOrderTaked = new gs.EventGS(this._onHotOrderTaked);
        this.onOrderChanged = new gs.EventGS(this._onOrderChanged);
        this.onNewHotOrder = new gs.EventGS(this._onNewHotOrder);
    }
    /**
     * @returns {Promise<boolean>}
     */
    open() {
        return __awaiter(this, void 0, void 0, function* () {
            this._needClose = false;
            let token = yield this.lockgui(this.app.api.driver.auth.authToken());
            let lastPushId = 0;
            let errorCount = 0;
            while (true) {
                if (new Date(token.until - 1000 * 5 * 6) < new Date()) {
                    token = yield this.app.api.driver.auth.authToken();
                }
                let request = {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json;charset=utf-8"
                    },
                    method: "POST",
                    body: JSON.stringify(token)
                };
                try {
                    if (errorCount > 3)
                        yield new Promise((resolve) => { setTimeout(() => resolve(true), 10000); });
                    if (this._needClose) {
                        return;
                    }
                    let response = yield fetch(this._url + this._endPoint + "?fromPushId=" + lastPushId, request);
                    if (this._needClose) {
                        return;
                    }
                    if (response.status == 504) {
                        errorCount = 0;
                        continue;
                    }
                    if (response.status == 205) {
                        this._onClose.invoke();
                        return;
                    }
                    if (response.status == 200) {
                        errorCount = 0;
                        let result = yield response.json();
                        for (const push of result) {
                            if (push.pushId > lastPushId)
                                lastPushId = push.pushId;
                            yield this._processingWSJsonMessage({ message: JSON.parse(push.messageJSON), type: push.type });
                        }
                        continue;
                    }
                    errorCount++;
                }
                catch (e) {
                    errorCount++;
                }
            }
        });
    }
    close() {
        this._needClose = true;
        this._onClose.invoke();
    }
    _processingWSJsonMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            let orderMessage;
            let enumType = SocketMessageTypeEnum_js_1.SocketMessageTypeEnum[message.type.toString()];
            switch (enumType) {
                case SocketMessageTypeEnum_js_1.SocketMessageTypeEnum.HotOrder:
                    orderMessage = new LPMessageOrder_js_1.default(message);
                    this._onNewHotOrder.invoke(orderMessage.order);
                    break;
                case SocketMessageTypeEnum_js_1.SocketMessageTypeEnum.HotOrderTaked:
                    orderMessage = new LPMessageOrder_js_1.default(message);
                    this._onHotOrderTaked.invoke(orderMessage.order);
                    break;
                case SocketMessageTypeEnum_js_1.SocketMessageTypeEnum.OrderChanged:
                    orderMessage = new LPMessageOrder_js_1.default(message);
                    this._onOrderChanged.invoke(orderMessage.order);
                    break;
                default:
                    break;
            }
        });
    }
}
exports.default = LongPollController;
//# sourceMappingURL=LongPollController.js.map